import React from "react";

// Section C (admin-only): the "شناسه" (colophon) field set shared by
// ArticleFormPage.js, TopicFormPage.js, and IssueTopicFormPage.js — four
// fixed fields plus a repeatable list of admin-defined "label: value"
// rows for anything those four don't cover (an issue number, a source
// publication, a license, ...). Mirrors FootnotesEditor.js's add/remove
// row pattern for the repeatable part.
function MetadataFieldsEditor({ metadata, onChange }) {
  function setField(field, value) {
    onChange({ ...metadata, [field]: value });
  }

  function setExtraField(index, key, value) {
    const extraFields = [...metadata.extra_fields];
    extraFields[index] = { ...extraFields[index], [key]: value };
    onChange({ ...metadata, extra_fields: extraFields });
  }

  function addExtraField() {
    onChange({ ...metadata, extra_fields: [...metadata.extra_fields, { label: "", value: "" }] });
  }

  function removeExtraField(index) {
    onChange({ ...metadata, extra_fields: metadata.extra_fields.filter((_, i) => i !== index) });
  }

  return (
    <div className="metadata-fields-editor">
      <div className="auth-field">
        <label htmlFor="metadata-english-author">نام نویسنده (انگلیسی)</label>
        <input
          id="metadata-english-author"
          type="text"
          dir="ltr"
          value={metadata.english_author_name}
          onChange={(e) => setField("english_author_name", e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label htmlFor="metadata-text-id">شناسهٔ متن</label>
        <input
          id="metadata-text-id"
          type="text"
          value={metadata.text_id}
          onChange={(e) => setField("text_id", e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label htmlFor="metadata-translator">نام مترجم</label>
        <input
          id="metadata-translator"
          type="text"
          value={metadata.translator_name}
          onChange={(e) => setField("translator_name", e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label htmlFor="metadata-bio">بیوگرافی نویسنده</label>
        <textarea
          id="metadata-bio"
          rows={3}
          value={metadata.author_bio}
          onChange={(e) => setField("author_bio", e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label>فیلدهای شناسهٔ اضافی (اختیاری)</label>
        {metadata.extra_fields.map((field, index) => (
          <div className="metadata-extra-row" key={index}>
            <input
              type="text"
              placeholder="عنوان"
              value={field.label}
              onChange={(e) => setExtraField(index, "label", e.target.value)}
            />
            <input
              type="text"
              placeholder="مقدار"
              value={field.value}
              onChange={(e) => setExtraField(index, "value", e.target.value)}
            />
            <button
              type="button"
              className="footnotes-editor-remove"
              onClick={() => removeExtraField(index)}
              aria-label="حذف این فیلد"
            >
              ×
            </button>
          </div>
        ))}

        <button type="button" className="footnotes-editor-add" onClick={addExtraField}>
          + افزودن فیلد
        </button>
      </div>
    </div>
  );
}

export default MetadataFieldsEditor;
